import { PreloadedQuery } from 'react-relay';

import { BootstrapQuery } from './__generated__/BootstrapQuery.graphql';
import { preloadQueryRef } from './preloadQueryRef';

let preloadedQueryRef: PreloadedQuery<BootstrapQuery> | null = null;

export const getPreloadedQueryRef = (): PreloadedQuery<BootstrapQuery> => {
	if (preloadedQueryRef) {
		return preloadedQueryRef;
	}

	preloadedQueryRef = preloadQueryRef();
	return preloadedQueryRef;
};
